import { cmApiUrl } from '@atc/cm-api-url';

import genericPostJSON from '@/utilities/genericPostJSON';

export default (requestBody) => {
    const endpoint = '/strong-attributes/calculate';
    if (navigator && navigator.sendBeacon) {
        navigator.sendBeacon(cmApiUrl(endpoint), JSON.stringify(requestBody));
    } else {
        genericPostJSON(cmApiUrl(endpoint), JSON.stringify(requestBody));
    }
};
